<template>
    <Datatable
            v-redirect-if-no-permission:VOUCHERS
            title="Phone Vouchers"
            :url="api.ACTIONS.PHONE_VOUCHERS"
            :fields-hidden-main='["deleted_at","updated_at","voucher_id"]'
            :fields-extra-add="fieldsExtraAdd"
            :formatter="formatter"
            :fields-hidden-add="['id','deleted_at','phone_number','updated_at','created_at','voucher']"
            :titles="titles"
            :enableEdit="false"
    />
</template>

<script>
    import Datatable from "@/components/wasilni/DataTable";

    export default {
        name: "List",
        title: 'Phone Voucher',
        components: {Datatable},
        computed: {
            fieldsExtraAdd() {
                return {
                    phone_numbers: 'choose-numbers',
                    voucher_id: 'choose-voucher'
                }
            },
            titles() {
                return {
                    phone_number: "Phone",
                    voucher_id: 'Voucher',
                    phone_numbers: "Phones"
                }
            },
            formatter() {
                return {
                    voucher(v) {
                        return v.code;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>